export default {
	readFileSync: () => null,
	// Add other fs methods you might be using
};
